import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-146">
      <div className="max-w-4xl mx-auto text-center" data-id="element-147">
        {/* Cost Table */}
        <h2 className="text-3xl sm:text-4xl font-black text-white mb-8" data-id="element-148">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
        <div className="bg-[#1a0d2e] border border-[#A855F7]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-149">
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#0d0818] border-b border-[#A855F7]/30" data-id="element-150">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-151">
              Sin MegaPack
            </div>
            <div className="p-4 font-bold text-[#A855F7] text-center sm:border-l border-[#A855F7]/30" data-id="element-152">
              Costo real
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-153">
            <div className="p-4 text-gray-400 text-sm" data-id="element-154">
              3 hs de planificación × 40 semanas
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#A855F7]/5 sm:border-l border-gray-800" data-id="element-155">
              120 horas de tu vida por año
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-156">
            <div className="p-4 text-gray-400 text-sm" data-id="element-157">
              Alumnos sin progreso visible
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#A855F7]/5 sm:border-l border-gray-800" data-id="element-158">
              Tasa de abandono alta — ingresos inestables
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-159">
            <div className="p-4 text-gray-400 text-sm" data-id="element-160">
              Clases grupales improvisadas
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#A855F7]/5 sm:border-l border-gray-800" data-id="element-161">
              Energía quemada — calidad baja
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-162">
            <div className="p-4 text-gray-400 text-sm" data-id="element-163">
              Sin sistema de cobros ni cancelaciones
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#A855F7]/5 sm:border-l border-gray-800" data-id="element-164">
              Dinero perdido cada semana
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-165">
            <div className="p-4 text-gray-400 text-sm" data-id="element-166">
              Sin criterio clínico en patologías
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#A855F7]/5 sm:border-l border-gray-800" data-id="element-167">
              Miedo a lesionar — frena el crecimiento
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-168">
            <div className="p-4 text-gray-400 text-sm" data-id="element-169">
              Sin herramientas de fidelización
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#A855F7]/5 sm:border-l border-gray-800" data-id="element-170">
              El mismo ciclo de búsqueda de alumnos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-171">
            <div className="p-4 text-gray-400 text-sm" data-id="element-172">
              Domingo buscando en internet
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#A855F7]/5 sm:border-l border-gray-800" data-id="element-173">
              El mismo ciclo — el próximo año
            </div>
          </div>
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3 italic" data-id="element-174">
          El próximo domingo puede ser diferente.
        </h2>
        <p className="text-[#A855F7] text-xl sm:text-2xl font-black mb-10 italic" data-id="element-175">
          &quot;La próxima clase puede ser la mejor que diste.&quot; 💪
        </p>

        {/* Countdown */}
        <div className="mb-10" data-id="element-176">
          <p className="text-white font-bold mb-4 text-xl" data-id="element-177">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-178" />
        </div>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-179">
          <div className="bg-[#0a0a0a] border border-[#A855F7]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-180">
            <div className="text-2xl mb-2" data-id="element-181">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-182">
              MEGAPACK PILATES LISTO
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-183">
              6 Tomos + 6 Bonos · Todos los niveles
            </p>
            <div className="mt-auto" data-id="element-184">
              <div className="text-gray-400 line-through text-sm mb-1" data-id="element-185">
                $89.000
              </div>
              <p className="text-[#A855F7] text-2xl font-black mb-4" data-id="element-186">
                $19.990 ARS
              </p>
              <a href="https://www.verticedigital.store/cart/52918911926383:1" className="btn-purple-pulse block bg-[#A855F7] text-white font-black py-4 rounded-lg hover:bg-[#C084FC] transition-colors text-sm" data-id="element-187">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#0d0818] border-2 border-[#A855F7] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(168,85,247,0.2)] flex flex-col" data-id="element-188">
            <div className="text-2xl mb-2" data-id="element-189">🏆</div>
            <h3 className="text-[#A855F7] font-black mb-1" data-id="element-190">
              MEGAPACK + ESPECIALISTA ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-191">
              6 Tomos + 6 Bonos + Manual de Posturología Experta
            </p>
            <div className="mt-auto" data-id="element-192">
              <div className="text-gray-400 line-through text-sm mb-1" data-id="element-193">
                $119.000
              </div>
              <p className="text-[#A855F7] text-3xl font-black mb-4" data-id="element-194">
                $27.990 ARS
              </p>
              <a href="https://www.verticedigital.store/cart/52918915858543:1" className="btn-purple-pulse block bg-[#A855F7] text-white font-black py-4 rounded-lg hover:bg-[#C084FC] transition-colors text-sm" data-id="element-195">
                → QUIERO EL MEGAPACK + ESPECIALISTA
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-196">
          <span data-id="element-197">🔒 Pago 100% seguro</span>
          <span data-id="element-198">⚡ Acceso en 5 minutos</span>
          <span data-id="element-199">🛡️ Garantía 7 días</span>
          <span data-id="element-200">💳 Mercado Pago — Tarjeta — Transferencia</span>
        </div>
      </div>
    </section>;
}